import React, { Suspense } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { Routes, Route } from 'react-router-dom';

import Search from 'features/search';
import Homepage from 'features/homepage';

const About = React.lazy(() => import('./features/about'));
const Adherences = React.lazy(() => import('./features/adherences'));
const Stats = React.lazy(() => import('./features/stats'));
const Admin = React.lazy(() => import('./features/admin'));
const InstrumentView = React.lazy(() => import('./features/instrument/instrument-view'));
const InstrumentDisplay = React.lazy(() => import('./features/instrument/display'));
const InstrumentEdit = React.lazy(() => import('./features/instrument/edit'));

const RootPages = () => {
  return (
    <Suspense fallback={<LinearProgress />}>
      <Routes>
        <Route path="about" element={<About />} />
        <Route path="instruments" element={<Search />}/>
        <Route path="instruments/*" element={<InstrumentView/>}>
          <Route path=":instrumentKey" element={<InstrumentDisplay/>}/>
          <Route path="create/*" element={<InstrumentEdit/>}/>
          <Route path=":instrumentId/edit/*" element={<InstrumentEdit/>}/>
        </Route>
        <Route path="adherences" element={<Adherences />} />
        <Route path="stats" element={<Stats />} />
        <Route path="settings" element={<Admin />} />
        <Route index element={<Homepage />} />
      </Routes>
    </Suspense>
  );
};

export default RootPages;
